/*
 * The club's bookplate: ex libris on cream paper with a brass border. Paper
 * and plate are physical things, like the books on the shelf, so they look
 * the same in dark and light. It fills in as the creation flow is answered,
 * then becomes the flyleaf of the club's first book at the finish.
 *
 * `full` is the desktop plate beside the form, `compact` the short one above
 * each step on a phone (the name and the latest line), and `page` sits on a
 * book's inside page, where type scales with the book (container units).
 */
export interface PlateFacts {
  name: string;
  description?: string;
  genres?: string[];
  pace?: string | null;
  pick?: string | null;
  /** the first book's title, once one is chosen */
  first?: string | null;
  /** "Open" or "Request to join", once chosen */
  find?: string | null;
}

export function Bookplate({ facts, variant = "full", latest }: { facts: PlateFacts; variant?: "full" | "compact" | "page"; latest?: string | null }) {
  const name = facts.name.trim();
  const genres = facts.genres?.length ? facts.genres.join(" · ") : null;
  if (variant === "compact") {
    return (
      <div className="bplate compact" aria-hidden="true">
        <div className="bp-ex">Ex libris</div>
        <div className={`bp-name${name ? "" : " unnamed"}`}>{name || "Your club"}</div>
        {latest && <div className="bp-line">{latest}</div>}
      </div>
    );
  }
  return (
    <div className={`bplate${variant === "page" ? " page" : ""}`} aria-hidden="true">
      <div className="bp-ex">Ex libris</div>
      <div className="bp-orn">❦</div>
      <div className={`bp-name${name ? "" : " unnamed"}`}>{name || "Your club"}</div>
      {facts.description?.trim() && <div className="bp-desc">{facts.description.trim()}</div>}
      {genres && <div className="bp-line">{genres}</div>}
      {facts.pace && <div className="bp-line">{facts.pace}</div>}
      {facts.pick && <div className="bp-line">{facts.pick}</div>}
      {facts.first && <div className="bp-line">First up: <i>{facts.first}</i></div>}
      {facts.find && <div className="bp-line">{facts.find}</div>}
    </div>
  );
}
